import AilabDocumentAPI from 'dashboard/api/ailab/document';
import { createStore } from './storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AilabDocument',
  API: AilabDocumentAPI,
  actions: mutationTypes => ({
    retry: async ({ commit }, id) => {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await AilabDocumentAPI.retry(id);
        commit(mutationTypes.UPSERT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
